import React, { useEffect, useState } from 'react';

function ChooseQualDailyQuiz({
  quals,
  qualIdForDailyQuiz,
  updateUserSettingQualForDailyQuiz,
  flashChoose,
  userSettingQualForDailyQuizMessage,
  setFlashSectionChoose,
  setUserSettingQualForDailyQuizMessage,
  loadingUpdateUserSettingQualForDailyQuiz,
}) {
  const [flash, setFlash] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  let timerID1;
  let timerID2;

  useEffect(() => {
    if (flashChoose && flashChoose.value && flashChoose.typeChoose === 'Qual') {
      setFlash(false);
      timerID1 = setTimeout(() => {
        setFlash(true);
        setFlashSectionChoose({ value: false, typeChoose: '' });
      }, 1500);
    }

    if (
      !loadingUpdateUserSettingQualForDailyQuiz &&
      userSettingQualForDailyQuizMessage &&
      userSettingQualForDailyQuizMessage.text
    ) {
      setShowMessage(true);
      timerID2 = setTimeout(() => {
        setShowMessage(false);
        setUserSettingQualForDailyQuizMessage('');
      }, 5000);
    }

    return () => {
      clearTimeout(timerID1);
      clearTimeout(timerID2);
    };
  }, [
    userSettingQualForDailyQuizMessage,
    loadingUpdateUserSettingQualForDailyQuiz,
  ]);

  return (
    <div className="choose-qual-settings" style={{ marginBottom: '1rem' }}>
      <div className={`profile-privacy ${flash ? 'flash' : ''}`}>
        <div className="profile-privacy-header">
          <div className="label">Choose Qual For Daily Quiz</div>
        </div>
        <div className="profile-privacy-body">
          <div className="radio-group">
            {quals && Array.isArray(quals) && quals.length > 0
              ? quals.map((qual) => (
                  <div className="radio-container" key={qual.id}>
                    <button
                      type="radio"
                      className="material-icons radio-icon radio-icon-choose-qual-settings p-0"
                      onClick={() => {
                        clearTimeout(timerID1);
                        clearTimeout(timerID2);
                        setUserSettingQualForDailyQuizMessage('');
                        updateUserSettingQualForDailyQuiz(qual.id);
                      }}
                      style={{
                        cursor: loadingUpdateUserSettingQualForDailyQuiz
                          ? 'not-allowed'
                          : 'pointer',
                      }}
                      disabled={loadingUpdateUserSettingQualForDailyQuiz}
                    >
                      {qualIdForDailyQuiz === qual.id
                        ? 'radio_button_checked'
                        : 'radio_button_unchecked'}
                    </button>
                    <div className="radio-label">{qual.name} </div>
                  </div>
                ))
              : 'No quals available for daily quiz'}
          </div>
        </div>
      </div>

      {showMessage && userSettingQualForDailyQuizMessage && (
        <div className={`message-${userSettingQualForDailyQuizMessage.type}`}>
          {userSettingQualForDailyQuizMessage.text}
        </div>
      )}
    </div>
  );
}

export default ChooseQualDailyQuiz;
